import { STORAGE_KEY } from '@utils/constants/storage'

/**
 * Convert a string to a slug (lowercase, no accents, no special chars, spaces replaced by hyphens).
 *
 * @param {string} str
 * @returns {string}
 */
export const toStorageSlug = str =>
  str
    // Convert to lowercase
    .toLowerCase()
    // Remove accents
    .normalize('NFD')
    // Remove special characters
    .replace(/[\u0300-\u036f]/g, '')
    // Remove all non-alphabetic characters except spaces and hyphens
    .replace(/[^a-z\s/-]/g, '')
    // Replace spaces and slashes with hyphens, and remove consecutive hyphens
    .replace(/[\/\s]+/g, '-')
    // Replace multiple hyphens with a single one
    .replace(/-+/g, '-')
    // Remove leading and trailing hyphens
    .replace(/^-+|-+$/g, '')

/**
 * Initializes and maintains the integrity of localStorage data across deployments.
 *
 * @returns {void}
 */
export function bootstrapLocalStorage() {
  const userStorageBuildId = localStorage.getItem(STORAGE_KEY.BUILD_ID)
  const currentBuildId = import.meta.env.BUILD_DATE

  /**
   * Check if the localStorage data is outdated by comparing the current build date with the one stored in localStorage build ID
   * If the build ID is not present, consider the localStorage data as outdated
   * and clean it up to avoid potential issues with incompatible data after a new deployment
   */
  const isOutDated = userStorageBuildId ? parseInt(userStorageBuildId) !== currentBuildId : true

  /**
   * If the localStorage data is outdated, remove all items related to build ID and columns visibility which are not relevant anymore
   * and set the new build ID with the current build date
   */
  if (isOutDated) {
    /**
     * Remove all localStorage items related to build ID and columns visibility
     * which are not relevant anymore after a new deployment
     */
    Object.keys(localStorage)
      .filter(
        key =>
          key.startsWith(STORAGE_KEY.BUILD_ID) || key.startsWith(STORAGE_KEY.COLUMNS_VISIBILITY)
      )
      .map(key => localStorage.removeItem(key))

    /**
     * Set current storage new build ID
     */
    localStorage.setItem(STORAGE_KEY.BUILD_ID, import.meta.env.BUILD_DATE)
  }
}
